import { Typography } from '@mui/material';
import { HighlightedText } from 'framework/ui/searchHighlight';
import { SingleLineNameFieldLayoutType } from '../../field';

const removeUselessSpaces = (str: string) => {
  return str.replace(/  +/g, ' ').trim();
};

const SingleLineNameFieldLayout: SingleLineNameFieldLayoutType = ({
  firstName = '',
  lastName = '',
  middleName = '',
  maidenName = '',
}) => {
  const name = `${firstName || ''} ${middleName || ''} ${lastName || ''} ${maidenName ? `(${maidenName})` : ''}`;

  return (
    <Typography variant="body1" component="span">
      <HighlightedText>{removeUselessSpaces(name)}</HighlightedText>
    </Typography>
  );
};

export default SingleLineNameFieldLayout;
